/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_AdminDashboard_AdminTaskDto } from '../models/Wealthlane_AwardService_Dtos_AdminDashboard_AdminTaskDto';
import type { Wealthlane_AwardService_Dtos_AdminDashboard_AdminUpcomingEventsDto } from '../models/Wealthlane_AwardService_Dtos_AdminDashboard_AdminUpcomingEventsDto';
import type { Wealthlane_AwardService_Dtos_AdminDashboard_OutStandingAwardsDto } from '../models/Wealthlane_AwardService_Dtos_AdminDashboard_OutStandingAwardsDto';
import type { Wealthlane_AwardService_Dtos_AdminDashboard_ParticipantActivitiesDto } from '../models/Wealthlane_AwardService_Dtos_AdminDashboard_ParticipantActivitiesDto';
import type { Wealthlane_AwardService_Dtos_AdminDashboard_PlanSummary } from '../models/Wealthlane_AwardService_Dtos_AdminDashboard_PlanSummary';
import type { Wealthlane_AwardService_Dtos_Dashboard_AwardAdminDashboardResponseDto } from '../models/Wealthlane_AwardService_Dtos_Dashboard_AwardAdminDashboardResponseDto';
import type { Wealthlane_AwardService_Dtos_MyHoldings_DashboardVestingScheduleDto } from '../models/Wealthlane_AwardService_Dtos_MyHoldings_DashboardVestingScheduleDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DashboardService {

    /**
     * @returns Wealthlane_AwardService_Dtos_Dashboard_AwardAdminDashboardResponseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardAdminDashboard(): CancelablePromise<Wealthlane_AwardService_Dtos_Dashboard_AwardAdminDashboardResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/admin-dashboard',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @deprecated
     * @returns Wealthlane_AwardService_Dtos_AdminDashboard_AdminTaskDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardAdminTasksV1(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_AdminDashboard_AdminTaskDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/admin-tasks-v1',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_AdminDashboard_AdminTaskDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardAdminTasks(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_AdminDashboard_AdminTaskDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/admin-tasks',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_AdminDashboard_AdminUpcomingEventsDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardUpcomingEvents(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_AdminDashboard_AdminUpcomingEventsDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/upcoming-events',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_AdminDashboard_ParticipantActivitiesDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardActivities(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_AdminDashboard_ParticipantActivitiesDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/activities',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_MyHoldings_DashboardVestingScheduleDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardVestingSummary(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_MyHoldings_DashboardVestingScheduleDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/vesting-summary',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_AdminDashboard_OutStandingAwardsDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardOutstandingAwards(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_AdminDashboard_OutStandingAwardsDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/outstanding-awards',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_AdminDashboard_PlanSummary OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardPlanSummary(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_AdminDashboard_PlanSummary>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/plan-summary',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
